

























import {
  reactive,
  defineComponent,
  onMounted,
  computed,
  toRefs,
  watch,
} from "@vue/composition-api"

export default defineComponent({
  name: "AppBar",

  setup(_, { root }) {
    const state = reactive({
      innerHeight: true,
    })

    const color = computed(() => {
      if (state.innerHeight) return "white"
    })

    const scroll = () => {
      if (
        root.$route.name === "Home" &&
        window.scrollY < window.innerHeight - 30
      )
        state.innerHeight = true
      else state.innerHeight = false
    }

    watch(() => root.$route.name, scroll)

    onMounted(() => {
      window.addEventListener("scroll", scroll)
    })

    return {
      ...toRefs(state),
      color,
    }
  },
})
